import { useQuery } from '@tanstack/react-query';
import { ApiService } from './api';

/** Global registration-document cap. Falls back to 10 MB when the setting has not loaded. */
export function useDocumentLimit() {
  const { data } = useQuery({
    queryKey: ['documentLimit'],
    queryFn: () => ApiService.getDocumentLimit(),
    staleTime: 60 * 1000,
  });
  const mb = Number(data?.maxDocumentMb) > 0 ? Number(data.maxDocumentMb) : 10;
  return { mb, bytes: mb * 1024 * 1024 };
}
